// Types
import type { TStepperPosition, TStepperStatus } from './Stepper.type';

// Constants
import { STEP_DEFAULT_PROPS, STEPPER_POSITION, STEPPER_STATUS } from './Stepper.constant';

export const getStepProps = (activeStep: number, maxIndex: number, index: number) => {
	let position: TStepperPosition = STEPPER_POSITION.middle!;
	let status: TStepperStatus = STEP_DEFAULT_PROPS.status!;
	const isFirst = index === 0;
	const isLast = index === maxIndex - 1;

	if (activeStep === index) {
		status = STEPPER_STATUS.active;
	} else if (activeStep > index) {
		status = STEPPER_STATUS.complete
	}

	if (isFirst) {
		position = STEPPER_POSITION.start;
	} else if (isLast) {
		position = STEPPER_POSITION.end;
	}

	return {
		isActive: activeStep === index,
		isFirst,
		isLast,
		position,
		status,
	}
}
